/* File : src/pages/GuestPages/RetrieveTicketPage.js */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { publicApi } from '../../services/api';
import { useEvent } from '../../contexts/EventContext';
import './GuestPages.css';

/**
 * Page permettant de récupérer son ticket via le numéro de téléphone
 */
const RetrieveTicketPage = () => {
  const navigate = useNavigate();
  const { selectedCity } = useEvent();
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  // Vérifier que l'utilisateur a sélectionné une ville
  useEffect(() => {
    if (!selectedCity) {
      navigate('/city-selection');
    }
  }, [selectedCity, navigate]);
  
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    setError('');
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation basique du numéro de téléphone
    if (!phone || !/^6[5-9][0-9]{7}$/.test(phone)) {
      setError('Veuillez entrer un numéro de téléphone camerounais valide (6xx xx xx xx)');
      return;
    }
    
    setLoading(true);
    
    try {
      // Vérifier si l'utilisateur est déjà inscrit
      const response = await publicApi.checkRegistration(phone);
      
      if (response.data.registered) {
        // Rediriger vers la page du ticket avec le numéro de téléphone
        navigate(`/ticket/${phone}`);
      } else {
        setError('Aucune inscription trouvée avec ce numéro de téléphone.');
      }
    } catch (err) {
      console.error('Error checking registration:', err);
      setError('Une erreur est survenue. Veuillez réessayer plus tard.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleBackToEvent = () => {
    navigate('/event');
  };
  
  const handleBackToHome = () => {
    navigate('/');
  };
  
  return (
    <div className="guest-page retrieve-ticket-page">
      <div className="retrieve-ticket-container">
        <div className="back-arrow" onClick={handleBackToEvent}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 19L5 12L12 5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <div className="retrieve-ticket-header">
          <img src="/assets/images/guinness-logo.png" alt="Guinness Cameroun" className="retrieve-ticket-logo" />
          <h1>Retrouver mon pass</h1>
          {selectedCity && (
            <div className="city-indicator">
              Événement : {selectedCity}
            </div>
          )}
          <p>Entrez le numéro de téléphone utilisé lors de votre inscription</p>
        </div>
        
        <div className="retrieve-ticket-form-container">
          <form onSubmit={handleSubmit} className="retrieve-ticket-form">
            <Input
              type="tel"
              id="phone"
              name="phone"
              label="Numéro de téléphone"
              placeholder="6XX XX XX XX"
              value={phone}
              onChange={handlePhoneChange}
              error={error}
              required
              disabled={loading}
            />
            
            <div className="retrieve-ticket-actions">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                disabled={loading}
              >
                {loading ? 'Recherche...' : 'Retrouver mon pass'}
              </Button>
              
              <Button
                type="button"
                variant="outline"
                size="md"
                fullWidth
                onClick={handleBackToEvent}
                disabled={loading}
              >
                Retour à l'événement
              </Button>
            </div>
          </form>
        </div>
        
        <div className="retrieve-ticket-footer">
          <p>
            La consommation d'alcool est réservée aux personnes majeures. 
            L'abus d'alcool est dangereux pour la santé, à consommer avec modération.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RetrieveTicketPage;